import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, take} from 'rxjs';
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import { AdminSession, CustomerSession } from 'libs/tm-common/src/lib/models/user.model';
import {CustomerRegistrationPayload, CustomerRegistrationResponse} from 'libs/tm-common/src/lib/models/customer-registration.model'
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'libs/tm-common/src/lib/store/reducers/reducers';
import { selectRedirectUrl } from 'libs/tm-common/src/lib/store/redirect-state/redirect.selector';
import { clearRedirectParams } from 'libs/tm-common/src/lib/store/redirect-state/redirect.actions';
@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private http = inject(HttpClient);
	private store = inject<Store<AppState>>(Store);
	private router = inject(Router);
	private config = inject<AppConfig>(APP_CONFIG_TOKEN);

	onSignin() {
		this.store
			.select(selectRedirectUrl)
			.pipe(take(1))
			.subscribe((url) => {
				if (url) {
					this.router.navigateByUrl(url);
				} else {
					this.router.navigate(["/"]);
				}
				this.store.dispatch(clearRedirectParams());
			});
	}

	login(email: string, password): Observable<CustomerSession> {
		const endPoint = '/auth/customer';
		return this.http
			 .post<CustomerSession>(`${this.config.apiUrl}${endPoint}`,
						{username: email, password: password}
			);
	}

	logout(): Observable<void> {
		const endPoint = '/auth/signout';
		return this.http.delete<void>(`${this.config.apiUrl}${endPoint}`);
	}

	resetPassword(username: string, isAdmin: boolean): Observable<void>{
		const body = {
			username: username
		}

		const endPoint = `/auth/${isAdmin ? 'admin' : 'customer'}/credentials/reset`;
		return this.http.post<void>(`${this.config.apiUrl}${endPoint}`, body);
	}

	adminLogin(userName: string, password): Observable<AdminSession> {
		const endPoint = '/auth/admin';
		return this.http
			.post<AdminSession>(`${this.config.apiUrl}${endPoint}`,
				{userName: userName, password: password}
			);
	}

	getMe(): Observable<CustomerSession | AdminSession | { isLoggedIn: false }> {
		const endPoint = '/auth/me';
		return this.http.get<CustomerSession | AdminSession | { isLoggedIn: false }>(`${this.config.apiUrl}${endPoint}`);
	}

	registerCustomer(registerDto: CustomerRegistrationPayload): Observable<CustomerRegistrationResponse>{
		const body = registerDto;
		const endPoint = `/customer/register`;
		return this.http.post<CustomerRegistrationResponse>(`${this.config.apiUrl}${endPoint}`, body);
	}
}
